export const LEGACY_SITE_URL = new URL(
	process.env.NEXT_PUBLIC_LEGACY_SITE_URL ?? "https://xx.aopsacademy.club"
);

/**
 * Returns the URL for the legacy site at a given campus.
 *
 * Example:
 * 		getLegacyCampusURL() => "https://xx.aopsacademy.club"
 * 		getLegacyCampusURL("national") => "https://xx.aopsacademy.club"
 * 		getLegacyCampusURL("san-diego") => "https://san-diego.xx.aopsacademy.club"
 */
export const getLegacyCampusURL = (campusId?: string | null): URL => {
	const url = new URL(LEGACY_SITE_URL);
	if (!campusId || campusId === "national") {
		return url;
	}
	url.host = `${campusId}.${url.host}`;
	return url;
};

const getLegacyCampusURLString = (campusId?: string | null) => {
	const legacyURL = getLegacyCampusURL(campusId);
	return legacyURL.toString();
};

export default getLegacyCampusURLString;
